module.exports = __webpack_public_path__ + "img/meet_us_london.ae4fa312.png";